import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { styled, alpha } from '@mui/material/styles';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import ElectricCarIcon from '@mui/icons-material/ElectricCar';
//Components
import PersonalDetailTab from './PersonalDetailTab';
import MyVehicle from './MyVehicle';

const StyledTabs = styled(Tabs)(({ theme }) => ({
  width: '100%',
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTabs-flexContainer': {
    justifyContent: 'center',
    gap: theme.spacing(2),
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  color: theme.palette.primary.main,
  backgroundColor: 'transparent',
  border: `2px solid ${theme.palette.primary.main}`,
  borderRadius: theme.shape.borderRadius * 1.5,
  fontWeight: 600,
  fontSize: '14px',
  letterSpacing: '0.3px',
  textTransform: 'none',
  minHeight: 44,
  minWidth: '180px',
  padding: '10px 35px',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  position: 'relative',
  overflow: 'hidden',
  zIndex: 100,
  '&:hover': {
    background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.15)} 0%, ${alpha(theme.palette.primary.light, 0.1)} 100%)`,
    borderColor: theme.palette.primary.dark,
    color: theme.palette.primary.dark,
    boxShadow: `0 4px 12px 0 ${alpha(theme.palette.primary.main, 0.3)}`,
  },
  '&.Mui-selected': {
    color: 'white',
    border: 'none',
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    boxShadow: `0 4px 14px 0 ${alpha(theme.palette.primary.main, 0.4)}`,
    '&:hover': {
      background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
      boxShadow: `0 6px 20px 0 ${alpha(theme.palette.primary.main, 0.6)}`,
    },
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function AccountTabs({userDetail}) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', overflowX: 'visible'}}>
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="account tabs"
        >
          <StyledTab icon={<PersonPinIcon />} sx={{ display: 'flex', alignItems: 'center', gap: 1, marginTop: 0.5, marginBottom: 2 }} label="Personal" />
          <StyledTab icon={<ElectricCarIcon />} sx={{ display: 'flex', alignItems: 'center', gap: 1, marginTop: 0.5, marginBottom: 2 }} label="My Vehicle" />
        </StyledTabs>
      </Box>
      <TabPanel value={value} index={0}>
        <PersonalDetailTab userDetail={userDetail} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <MyVehicle />
      </TabPanel>
    </Box>
  );
}